<template>
    <div class="wuliankanban">
        <!-- <div class="wulian-top">望江山医院空调系统能耗数据看板</div> -->
        <div class="wulian-top">数据看板</div>
        <!-- 左边 -->
        <div class="wl-left">
              <div class="san-roud">
                  <div class="round">
                      <img src="../../assets/wulianKanban/round.png" alt="">
                      <div class="num">
                        <p>500</p>
                        <p>(台)</p>
                     </div>
                       <p>空调数量</p>
                      
                  </div>
                  <div class="round">
                    <img src="../../assets/wulianKanban/round.png" alt="">
                      <div class="num">
                        <p>22523.56</p>
                        <p>(kw.h)</p>
                     </div>
                      <p>本月用电量</p>
                  </div>
                  <div class="round">
                    <img src="../../assets/wulianKanban/round.png" alt="">
                      <div class="num">
                        <p>500</p>
                        <p>(kw.h)</p>
                     </div>
                     <p>当天用电量</p>
                  </div>
              </div>
              <div class="rangking">
                  <div class="top-title">
                      <span>当天用电排名TOP4</span>
                  </div>
                  <div class="slider-item">
                     <el-slider v-model="value2"></el-slider>
                      <div class="num"><span>1号空调</span><span>10600</span></div>
                  </div>
                  <div class="slider-item">
                     <el-slider v-model="value2"></el-slider>
                      <div class="num"><span>2号空调</span><span>10600</span></div>
                  </div>
                  <div class="slider-item">
                     <el-slider v-model="value2"></el-slider>
                      <div class="num"><span>3号空调</span><span>10600</span></div>
                  </div>
                  <div class="slider-item">
                     <el-slider v-model="value2"></el-slider>
                      <div class="num"><span>4号空调</span><span>10600</span></div>
                  </div>
              </div>
              <div class="ele-chart">
                  <div class="top-title">
                      <span>近七天总用电量趋势</span>
                       <span v-show="false">{{nowSvgItem}}</span>
                  </div>
                   <div class="chart">
                     <div id="main3" style="width: 100%;height:250px;"></div>
                </div> 
              </div>
        </div>
        <!-- 中间图形 -->
        <div class="middle" @mouseenter="btnFlag = true" @mouseleave="btnFlag = false">
            <webSvgPlayer :svgpath="realPath" ref="webSvgPlayer" class="webSvgPlayer" slot="body"></webSvgPlayer>
             <div class="add-svg" @click="dialogSvg = true" v-if="realPath == '' && btnFlag">
                <i class="el-icon-plus"></i>
             </div>
             <div class="svg-btn" v-if="realPath != '' && btnFlag" @click="dialogSvg = true ">
                切换
             </div>
        </div>
        <!-- 右边 -->
        <div class="wl-right">
            <div class="dashboard">
                <div class="item">
                    <div id="poweron" style="width: 100%;height:200px;"></div>
                    <p>空调开机率</p>
                </div>
                <div class="item">
                    <div id="poweron2" style="width: 100%;height:200px;"></div>
                    <p>空调故障率</p>
                </div>
            </div>
            <div class="alarm-info">
                 <div class="top-title">
                      <span>实时报警信息</span>
                  </div>
                  <ul class="uls">
                     <li>
                        <div>
                            <p class="btns alarm">告警</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                      <li>
                        <div>
                            <p class="btns warning">预警</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                      <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>
                       <li>
                        <div>
                            <p class="btns notice">通知</p>
                            <p>1号空调 - 用电量超额</p>
                        </div>
                        <span>11-23 09:11</span>
                     </li>

                  </ul>
            </div>
        </div>
        <!-- 弹出树形 -->
        <el-dialog width="20%" v-dialogDrag title="SVG图形"  :close-on-click-modal='false'
             :visible.sync="dialogSvg">
			<div class="address">
				<svgTree ref="svgTree" @checkItem="nowSvg = $event" slot="tree"></svgTree>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogSvg = false">取 消</el-button>
				<el-button type="primary" @click="nowPath_fn">确 定</el-button>
			</div>
		</el-dialog>
    </div>
</template>

<script>
import svgTree from '@/components/module/tree/svgTree.vue'
import webSvgPlayer from '@/components/module/svg/webSvgPlayer.vue'
export default {
components: {
			svgTree,
            webSvgPlayer
		},
    data() {
        return {
            nowSvg: {},
            value2:50,
            //近七天电量
           trendOption:{
                    tooltip: {
                        trigger: 'axis'
                    },
                   
                    grid: {
                        top:'10%',
                        left: '0%',
                        right: '5%',
                        bottom: '15%',
                        containLabel: true
                    },
                    xAxis: [{
                        type: 'category',
                        boundaryGap: false,   
                        data: ['1','2','3','4','5','6','7'],
                            //  改变x轴颜色
                            axisLine:{
                                lineStyle:{
                                    color:'#fff',
                                }
                            },                         
                            //  改变x轴字体颜色和大小  
                            axisLabel: {
                                textStyle: {
                                    color: '#fff',
                                    fontSize:'16'
                                },
                            }, 
                             "axisLine": {       //y轴
                                "show": false
                            },
                            "axisTick": {       //y轴刻度线
                                    "show": false
                                },
                            
                            splitLine:{ //网格线
                                show:false
                                }  
                            }],
                        
                    yAxis: [
                        {
                        type: 'value',
                        
                    //  改变y轴颜色
                            axisLine:{
                                lineStyle:{
                                    color:'#2A5D75',
                                }
                            },                         
                            //  改变y轴字体颜色和大小  
                        axisLabel: {
                            formatter: '{value}  ', //  给y轴添加单位 
                                textStyle: {
                                    color: '#fff',
                                    fontSize:'16',
                                
                                },
                            }, 
                             "axisLine": {       //y轴
                                "show": false
                            },
                            "axisTick": {       //y轴刻度线
                                "show": false
                            },
                            splitLine:{ // 网格线
                                lineStyle:{
                                    type:'dashed'//虚线
                                },
                                show:true
                            }   
                    }],
                    series: [                
                            {
                                name:'电（kW·h）',
                                type:'line',
                                // smooth: true,
                                // symbol: "none",
                                stack: '总量',
                                data:[10, 700, 100, 300, 200, 400, 600],
                                itemStyle:{
                                    normal:{
                                        color:'#1fa2fc' //  给折线添加颜色 
                                    },
                                }, 
                                
                                 areaStyle: {
                                    color: '#1b6d9e',
                                    opacity: 0.3
                                }
                            },               
                           
                            
                            ]
                },
            //空调开机率仪表盘
            option :{
                series: [
                    {
                    type: "gauge", // 仪表盘
                    max: 100, // 仪表盘最大值
                    splitNumber: "10", // 仪表盘的段数
                    axisLine: {
                        lineStyle: {
                          width: 8,
                          color: [
                                [1,new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                {
                                    offset: 0.1,
                                    color: "#31fff3"
                                },
                                {
                                    offset: 1,
                                    color: "#2e8eff"
                                }
                                ])
                            ]
                            ]
                        },
                    },
                    pointer: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#fff",
                        distance: -48,
                        fontSize: 12,
                        formatter: function (value) {
                        if (
                            value === 0 ||
                            value === 100
                        ) {
                            return value;
                        }
                        },
                    },
                    detail: {
                        show: false,
                    },
                    },
                    {
                    type: "gauge",
                    max: this.max,
                    radius: "58%",
                    axisLine: {
                        lineStyle: {
                        width: 8,
                        color: [
                                [1,new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                {
                                    offset: 0.1,
                                    color: "#31fff3"
                                },
                                {
                                    offset: 1,
                                    color: "#2e8eff"
                                }
                                ])
                            ]
                            ]
                        },
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        clip: false,
                        itemStyle: {
                        color: "red",
                        },
                    },
                    pointer: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                    title: {
                        show: true,
                        color: "#2fcbf8",
                        offsetCenter: [0, "20%"],
                        fontSize: "14",
                    },
                    detail: {
                        valueAnimation: true,
                         textStyle: {       
                            fontWeight: 'normal',
                            //里面文字下的数值大小（50）
                            color:'#31fff3',
                            fontWeight:600
                        },
                        offsetCenter: [0, "0%"],
                        fontSize: "25",
                        formatter: '{value} %',
                    },
                    data: [
                        // , name: '空调开机率'
                        { value: 40 }
                    ],
                    },
                ],
            },
            dialogSvg:false,//控制svg图形弹出
            realPath:"",
            btnFlag:false,
            nowSvgItem:{},
            svgDataList: [],
            conformArr:[],
            svgPath:""
        };
    },

    mounted() {
    
        var myChart3 = echarts.init(document.getElementById('main3'));
          myChart3.setOption(this.trendOption);
        var myPoweron  = echarts.init(document.getElementById('poweron'));
          myPoweron.setOption(this.option);

           var myPoweron2  = echarts.init(document.getElementById('poweron2'));
          myPoweron2.setOption(this.option);

        this.nowSvgItem = this.$store.svgStore.state.nowSvgItem
         this.diguiFilter(this.nowUnit.id, [this.getSvgTree])
       
    },
    watch:{
        nowSvg(v){
            if(v !=  undefined) {
                   if (v.fileName == undefined) {
                        this.svgPath = ""
                    }
                    this.svgPath =  "/static/svgFile/" + v.fileName
                    // return "/static/svgFile/" + '污水厂.wdr.38.svg'
                    // this.realPath = "/static/svgFile/" + 'ST1.wdr.98.svg'
                    // this.tran_fn()
            }
        },
        nowSvgItem(v){
            if(v == undefined){
                this.digui(this.dataList)
                this.realPath =  "/static/svgFile/" + this.nowSvg.fileName
            }else {
                this.nowSvg = v
                this.realPath =  "/static/svgFile/" + v.fileName
            }

        },
        nowUnit(nv, ov) {
				this.diguiFilter(nv.id, [this.getSvgTree])
        },
        dataList(nv){},
        realPath(){
              this.tran_fn()
        }
       
    },
    computed: {
            getSvgTree() {
                var data = this.$store.svgStore.getters.getSvgTree
                return data
                    
            },
            nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
            dataList() {
				var data = this.svgDataList
				return isempty(data) ? [] : svgList([data])
			},
			svgList() {
				if(this.dataList[0] == undefined) {
					return []
				}
				return treeToList(this.dataList[0], 'next', item => item.hasOwnProperty('next')).filter(item => item.entityName ==
					'Page')
			},
 },
    methods: {
        nowPath_fn(){
                //   if (this.nowSvg.fileName == undefined) {
                //         this.realPath =  ''
                //     }
                //     this.realPath =  "/static/svgFile/" + this.nowSvg.fileName
                    // return "/static/svgFile/" + '污水厂.wdr.38.svg'
                    this.$store.svgStore.commit('getNowSvg',this.nowSvg)
                    this.realPath = this.svgPath
                    this.tran_fn()
                    this.dialogSvg = false
        },
        tran_fn(){
             const iframe =  document.querySelector(".iframe")
                        iframe.addEventListener('load', () => {
                            const svgDoc = iframe.contentDocument
                            const svgEl = svgDoc.querySelector('svg')
                            const gEl = svgDoc.querySelectorAll('g')
                            for(let i = 0;i<gEl.length;i++){
                                if(gEl[i].getAttribute('to') && gEl[i].getAttribute('to')== 'body开始 有它kitfox java版本的快会快'){
                                    var rescEl = gEl[i].querySelector('rect')
                                    rescEl.style.fill = 'transparent'
                                }
                            }
                            svgEl.style.backgroundColor = 'transparent'   // 修改SVG图的fill颜色为红色
                        })
        },

        digui(list) {
				 this.conformArr = []
				list.forEach(item => {
					if(!isempty(item.children)) {
						this.digui(item.children)
					} else {
						if(item.entityName == "Page") {
							/*if(isempty(this.defaultSvg)) {*/
						    this.conformArr.push(item)
							/*}*/
						}
					}
				})
				this.nowSvg = this.conformArr[0]
			},
            diguiFilter(id, list) {
				list.forEach(item => {
					if(item.id == id) {
						this.svgDataList = item
					} else {
						if(!isempty(item.next)) {
							this.diguiFilter(id, item.next)
						}
					}
				})
			}

    },
};
</script>

<style lang="scss" scoped>
  .wuliankanban {
    width: 100%;
    height: 100%;
    background: url(../../assets/wulianKanban/wulian.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    position: relative;
    .wulian-top {
       position: absolute;
       color: #fff;
       font-size: 38px;
       width: 100%;
       display: flex;
       justify-content: center;
       margin-top: 10px;
       font-weight: 600;
       background-image: linear-gradient(to top, #4897ff , #84d3e3); /* 线性渐变背景，方向向上 */
        -webkit-background-clip: text; /* 背景被裁剪成文字的前景色 */
        -webkit-text-fill-color: transparent; /* 文字填充颜色变透明 */   


    }
    .wl-left {
        width: 21%;
        height: calc(100% - 100px);
        margin-left: 3%;
        margin-top: 3%;
        .san-roud {
            width: 100%;
            height: 17%;
            margin-top: 30px;
            display: flex;
            .round{
                width: 33.33%;
                position: relative;
                color: #fff;
                text-align: center;
                flex-shrink: 0;
            }
            img {
                width: 100%;
                height: 90%;
            }
            .num {
                color: #fff;
                position: absolute;
                top: 30%;
                left: 50%;
                transform: translateX(-50%);
                text-align: center;
                p:last-child {
                     font-size: 12px;
                }
            }
        }
         
        .rangking {
            width: 100%;
            height: 32%;
            margin-top: 18%;
          
           
            .slider-item {
                color: #fff;
                
                .num {
                    display: flex;
                    justify-content: space-between;
                }
                /deep/.el-slider__runway{
                    background-color: #193147;
                    margin-top: 20px;
                    margin-bottom: 5px;
                }
                /deep/.el-slider__bar {
                    background-image: linear-gradient(to right, #8fe6fe , #0c97fc);
                }
                /deep/.el-slider__button {
                    width: 3px;
                    height: 10px;
                    border: 0px;
                    border-radius: 4px;
                }
            }
        }

        .ele-chart {
            width: 100%;
            height: 30%;
            margin-top: 16%;
            .top-title {
                 margin-bottom: 0px;
            }
        }
    }
    .middle {
        overflow: hidden;
        width: 47.3%;
        height: 84%;
         margin:0 2.2%;
         margin-top: 5%;
         background: url(../../assets/wulianKanban/middle.png) no-repeat;
         background-size: 100% 100%;
         position: relative;
         
         .add-svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 150px;
            height: 150px;
            border: 1px dashed #cccccc;
            border-radius: 4px;
            text-align: center;
            line-height: 150px;
             
            &:hover {
                border-color: #0c97fc;
                i {
                    color: #0c97fc;
                }
            }
            i {
               color: #cccccc;
                font-size: 25px;
            }

         }
         .svg-btn {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 50px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            color: #cccccc;
            border-radius: 4px;
            border: 1px solid #cccccc;
            cursor: pointer;
            &:hover {
                 border-color: #0c97fc;
                color: #0c97fc;
            }
         }
    }
    .wl-right {
        width: 21%;
         margin-top: 3.5%;
         .dashboard {
            width: 100%;
             height: 18%;
             display: flex;
             color: #fff;
             text-align: center;
            .item {
                width: 50%;
                height: 100%;
                p {
                    position: relative;
                    top: -20px;
                }
            }
         }
         .alarm-info {
            width: 100%;
            height: 58%;
            // background-color: red;
            margin-top: 30%;

            ul {
                width: 100%;
                height: 88%;
                overflow: hidden;
                li {
                    width: 100%;
                    height: 26px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: #fff;
                    margin-top: 15px;
                    div{
                        display: flex;
                        align-items: center;
                    }
                    .btns {
                        margin-right: 12px;
                        width: 40px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        border: 1px solid #EC502E;
                        border-radius: 4px;
                        font-size: 12px;
                    }
                    .alarm {
                        border-color: #EC502E;
                        color: #EC502E;
                    }
                    .notice {
                         border-color: #2CAC95;
                        color: #2CAC95;
                    }
                    .warning {
                         border-color: #E0832E;
                        color: #E0832E;
                    }
                    span {
                        color: #999999;
                    }

                }
            }
         }
    }
     .top-title {
                width: 100%;
                height: 30px;
                color: #fff;
                background: url(../../assets/wulianKanban/title.png) no-repeat;
                background-size: 100% 100%;
                line-height: 30px;
                span {
                    margin-left: 12%;
                    font-weight: bold;
                }
                margin-bottom: 10px;
            }
    .address {
        width: 100%;
        height: 400px;
        display: flex;
        justify-content: center;

    }
    /deep/.framediv {
        width: 102%;
    height: 103%;
    }
    /deep/.svg {
        overflow: hidden;
    }
           
             /deep/.el-dialog__header {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #f5f5f5;
                span {
                    color: #67A3ED;
                    font-size: 16px;
                }
                .el-icon-close{
                    font-size: 22px !important;
                }

            }
    /deep/.el-dialog__footer {
        margin-top: 20px;
        text-align: right !important;
        border-top: 1px solid #f5f5f5;
        button{
            padding: 8px 17px;
        }
    }
    /deep/.el_Tree_Body{
        height: 99.5%;
    }
  }
</style>